import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { SearchQueryService } from '@app/core/services/search/resource-search/search-query.service';
import { DatasetSearchColumnFields } from '../gridOptions/dataset-search-grid-options-formatter';
import { ISearchDataSourceOptions, SearchDataSource } from './search.datasource';
import { ISearchFilter } from '@app/core/services/search/resource-search/search-query-types.service';

export class DatasetSearchDataSource extends SearchDataSource {
    constructor(
        searchQueryService: SearchQueryService,
        resourceDictionaryService: SearchResourceDictionaryService,
        dataSourceOptions: ISearchDataSourceOptions
    ) {
        const appResourceDictionary = resourceDictionaryService.getResourceConfigByType(SearchResourceType.Dataset);
        super(searchQueryService, appResourceDictionary, dataSourceOptions);

        const filterMethods: {[field: string]: (field: string, filterObj: any) => ISearchFilter} = {
            Project: (field, filterObj) => {
                return {
                    facets: ['Project.Id'],
                    currentChoice: {
                        value: filterObj.value,
                        label: null,
                    }
                }
            }
        };

        this.filterMethods = filterMethods as any;
    }

    get rawTextFilterColumnName(): string {
        return DatasetSearchColumnFields.Name;
    }
}
